import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

function PasswordInput({ value, label, name, hasError, onChange, ...rest }) {
	function disableCntrls(e) {
		if (e.keyCode == 17 || e.keyCode == 93) {
			alert('Copy Paste not allowed');
			return false;
		}
	}
	return (
		<React.Fragment>
			<div className="material-input">
				<input
					className={hasError ? 'hasError' : ''}
					{...rest}
					id={name || undefined}
					name={name}
					onChange={onChange}
					onKeyDown={e => disableCntrls(e)}
				/>
				{
					<label style={{ opacity: value?.length > 0 ? 1 : 0 }} htmlFor={name}>
						{label}
					</label>
				}
			</div>
			<div className="input-error-label">{hasError}</div>
		</React.Fragment>
	);
}
PasswordInput.propTypes = {
	value: PropTypes.string,
	hasError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};
PasswordInput.defaultProps = {
	value: '',
	hasError: false
};

export default PasswordInput;
